import React from 'react'
import ComparableTable from './ComparableTable'
import { isSimilarityMethod } from '../../helpers/valuationMethods'

export const getValuationComparables = (valuation) => {
  if (valuation?.comparables?.length) return valuation.comparables
  const acceptedStep = [...(valuation?.ladderData || [])].reverse().find((step) => !step.skipped && step.properties?.length)
  return acceptedStep?.properties || []
}

const ValuationComparablesSection = ({
  valuation,
  viewMode = 'private',
  recalculationError,
  recalculatingPropertyId,
  onResetExclusions,
  onResetWeightOverrides,
  onIgnoreProperty,
  onWeightOverride,
  onOpenProperty,
  onHoverProperty,
}) => {
  const publicMode = viewMode !== 'private'
  const demoMode = viewMode === 'demo'
  const comparables = getValuationComparables(valuation)

  return (
    <div className="bg-white rounded-lg shadow p-4 sm:p-6">
      {comparables.length > 0 ? (
        <>
          <h2 className="text-sm sm:text-lg font-medium text-gray-900 mb-2">Použitá srovnání</h2>
          <p className="mb-4 text-xs text-gray-500">
            Seřazeno od nejrelevantnější nabídky. Relevance určuje vliv nabídky na výsledný vážený průměr.
          </p>
          {!publicMode && recalculationError && <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-3 text-xs sm:text-sm text-red-700">{recalculationError}</div>}
          {!publicMode && valuation.excludedPropertyIds?.length > 0 && (
            <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
              <span className="text-xs sm:text-sm text-amber-900">Ignorovaná srovnání: {valuation.excludedPropertyIds.length}</span>
              <button
                type="button"
                disabled={Boolean(recalculatingPropertyId)}
                onClick={onResetExclusions}
                className="text-xs font-medium text-amber-800 hover:text-amber-950 disabled:text-gray-400 disabled:cursor-wait"
              >
                {recalculatingPropertyId === 'reset-exclusions' ? 'Přepočítávám…' : 'Obnovit všechna a přepočítat'}
              </button>
            </div>
          )}
          {!publicMode && isSimilarityMethod(valuation.calculationMethod) && Object.keys(valuation.comparableWeightOverrides || {}).length > 0 && (
            <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-blue-200 bg-blue-50 p-3">
              <span className="text-xs sm:text-sm text-blue-900">
                Ručně upravené váhy: {Object.keys(valuation.comparableWeightOverrides).length}
              </span>
              <button
                type="button"
                disabled={Boolean(recalculatingPropertyId)}
                onClick={onResetWeightOverrides}
                className="text-xs font-medium text-blue-800 hover:text-blue-950 disabled:cursor-wait disabled:text-gray-400"
              >
                {recalculatingPropertyId === 'reset-weights' ? 'Přepočítávám…' : 'Obnovit automatické váhy'}
              </button>
            </div>
          )}
          {!publicMode && Object.keys(valuation.comparableOverrides || {}).length > 0 && (
            <div className="mb-4 rounded-lg border border-blue-200 bg-blue-50 p-3 text-xs text-blue-900">
              Hodnoty upravené pouze pro tento odhad: {Object.keys(valuation.comparableOverrides).length}
            </div>
          )}
          <ComparableTable
            properties={comparables}
            subjectM2={valuation.m2}
            onIgnoreProperty={publicMode ? undefined : onIgnoreProperty}
            onWeightOverride={publicMode ? undefined : onWeightOverride}
            onOpenProperty={onOpenProperty}
            onHoverProperty={onHoverProperty}
            calculationMethod={valuation.calculationMethod}
            recalculatingPropertyId={publicMode ? null : recalculatingPropertyId}
            showDetailLinks={!demoMode}
            lockedComparablesCount={demoMode ? valuation.lockedComparablesCount || 0 : 0}
          />
        </>
      ) : (
        <>
          <h2 className="text-sm sm:text-lg font-medium text-gray-900 mb-4 sm:mb-6">Použitá srovnání</h2>
          <p className="text-xs sm:text-sm text-gray-500 italic">Žádná srovnání nejsou k dispozici.</p>
        </>
      )}
    </div>
  )
}

export default ValuationComparablesSection
